var _excluded = ["allowTargetAttribute", "allowIframeTag", "children", "tag", "className", "resetSpacing", "withSanitize"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import classNamesMaker from "classnames";
import { getAuthorizedRestProps } from "#library/utils/propsUtil";
import { TextWithDangerouslyInnerHtml } from "#library/components/Text/TextWithDangerouslyInnerHtml";
import styles from "./RichText.module.css";

/**
 * The type of all the props of the TextWithDangerouslyInnerHtml component
 */

/**
 * The 2 types of the RichText component
 */

/**
 * Represents a rich text adding the common styles for list, tables, images...
 */
// eslint-disable-next-line react/function-component-definition
export function RichText(_ref) {
  var _ref$allowTargetAttri = _ref.allowTargetAttribute,
    allowTargetAttribute = _ref$allowTargetAttri === void 0 ? false : _ref$allowTargetAttri,
    _ref$allowIframeTag = _ref.allowIframeTag,
    allowIframeTag = _ref$allowIframeTag === void 0 ? false : _ref$allowIframeTag,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? "" : _ref$children,
    tag = _ref.tag,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$resetSpacing = _ref.resetSpacing,
    resetSpacing = _ref$resetSpacing === void 0 ? false : _ref$resetSpacing,
    _ref$withSanitize = _ref.withSanitize,
    withSanitize = _ref$withSanitize === void 0 ? true : _ref$withSanitize,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * We force the tag to div to allow the use of paragraphs, and avoid invalid tag nesting
   * e.g : <p> <p></p> </p> ❌ => <div> <p></p> </div> ✅
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var CustomTag = tag || "div";
  return /*#__PURE__*/React.createElement(TextWithDangerouslyInnerHtml, _extends({}, getAuthorizedRestProps(rest), {
    className: classNamesMaker(styles["jds-RichText"], resetSpacing && styles["jds-RichText--resetSpacing"], className),
    allowTargetAttribute: allowTargetAttribute,
    allowIframeTag: allowIframeTag,
    tag: CustomTag,
    withSanitize: withSanitize
  }), children);
}